/**
 * Gate de sessão admin: troca cookie CF Access pelo JWT interno na primeira
 * carga. Se a sessão não existir/expirar, exibe uma tela neutra com a opção
 * de tentar de novo.
 */

import { useEffect, useState } from "react";
import { definirTokenAdmin, definirUsuarioAdmin, ErroApi, iniciarSessaoAdmin } from "../lib/api.js";
import { Botao, LogoSentinela } from "./ui/index.js";

interface Props {
  children: React.ReactNode;
}

export function SessionGate({ children }: Props) {
  const [estado, setEstado] = useState<"carregando" | "ok" | "erro">("carregando");
  const [mensagem, setMensagem] = useState<string | null>(null);

  useEffect(() => {
    iniciarSessaoAdmin()
      .then((r) => {
        definirTokenAdmin(r.token);
        definirUsuarioAdmin(r.user);
        setEstado("ok");
      })
      .catch((err) => {
        const codigo = err instanceof ErroApi ? err.codigo : "rede";
        setMensagem(traduzir(codigo));
        setEstado("erro");
      });
  }, []);

  if (estado === "carregando") {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-ink-50">
        <LogoSentinela tamanho="lg" />
        <div className="flex items-center gap-2 text-sm text-muted">
          <span className="inline-block h-3 w-3 animate-spin rounded-full border-2 border-magenta-500 border-r-transparent" />
          Autenticando…
        </div>
      </div>
    );
  }

  if (estado === "erro") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-ink-50 p-4">
        <div className="max-w-md w-full text-center">
          <LogoSentinela tamanho="lg" />
          <h1 className="mt-8 text-2xl font-display font-bold text-ink-800">
            Acesso indisponível
          </h1>
          <p className="text-sm text-muted mt-2">{mensagem}</p>
          <div className="mt-6">
            <Botao onClick={() => location.reload()} variante="primary">
              Tentar novamente
            </Botao>
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}

function traduzir(codigo: string): string {
  switch (codigo) {
    case "cf_access_ausente":
      return "Faça login pelo Cloudflare Access primeiro.";
    case "usuario_nao_autorizado":
      return "Seu e-mail não está cadastrado no Sentinela. Solicite acesso ao administrador.";
    default:
      return "Não foi possível iniciar a sessão. Tente novamente em alguns instantes.";
  }
}
